export const ANONYMOUS_MAIN_ROUTE_NAME = Symbol('anonymous.main');
export const TRANSLATION_GROUP_ANONYMOUS_MAIN = Symbol('anonymous-main');
